import { render } from "./PartenairesHome.vue?vue&type=template&id=78f8b71e"
import script from "./PartenairesHome.vue?vue&type=script&lang=js"
export * from "./PartenairesHome.vue?vue&type=script&lang=js"

import "./PartenairesHome.vue?vue&type=style&index=0&id=78f8b71e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__